import { usePageTemplates } from '@wordpuppi/shared';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const DEFAULT_LABEL = 'Default (page.html)';

/**
 * AB#945 — which theme template renders the page. `null` = the theme's
 * `page.html`, which is therefore never listed twice.
 */
export function PageTemplateSelect({ siteSlug, value, onChange }: { siteSlug: string; value: string | null; onChange: (template: string | null) => void }) {
  const { data } = usePageTemplates(siteSlug);
  // The current value stays selectable even if the theme no longer lists it.
  const options = [...new Set([...(data?.data ?? []), ...(value ? [value] : [])])].filter((t) => t !== 'page.html');
  return (
    <div className="space-y-2">
      <Label htmlFor="template">Template</Label>
      <Select value={value ?? ''} onValueChange={(v: string) => onChange(v || null)}>
        <SelectTrigger id="template">
          <SelectValue placeholder={DEFAULT_LABEL} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="">{DEFAULT_LABEL}</SelectItem>
          {options.map((t) => (
            <SelectItem key={t} value={t}>{t}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
